import * as Yup from "yup";
import {
  emailValidation,
  fullNameValidation,
  phoneValidation,
} from "../../../Utils/ValidationSchema";

const validationSchema = (t) =>
  Yup.object({
    manager_full_name: fullNameValidation(),
    manager_email: emailValidation(),
    manager_phone_number: phoneValidation(),
    community_name: Yup.string()
      .required(t("validation-error-messages:community_name_required"))
      .matches(/^.{3,}$/, t("validation-error-messages:community_name_min")),
    description: Yup.string()
      .optional()
      .max(1024, t("validation-error-messages:community_description_max")),
    platforms: Yup.array().of(
      Yup.object().shape({
        type: Yup.string().required(
          t("validation-error-messages:platform_required")
        ),
        link: Yup.string().required(
          t("validation-error-messages:url_required")
        ),
      })
    ),
  });

export default validationSchema;
